export default __webpack_public_path__ + "static/media/icon-consulting-blue.8f77be0c.svg";